<template>
    <vs-popup classContent="popup-example"  title="افزودن کاربر جدید" :active.sync="showPopup">
        <div class="vx-col w-full mb-base" @keydown.enter="addUserInfo()">
            <div class="vx-row">
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-user"
                        icon-no-border
                        label-placeholder="نام"
                        v-model="addUser.name"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-user"
                        icon-no-border
                        label-placeholder="نام خانوادگی"
                        v-model="addUser.last_name"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-smartphone"
                        icon-no-border
                        label-placeholder="شماره موبایل"
                        v-model="addUser.phone_number"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        name="email"
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-mail"
                        icon-no-border
                        label-placeholder="ایمیل"
                        v-model="addUser.email"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder">
                        <div class="vs-con-input">
                            <pdatepicker
                                placeholder="تاریخ تولد"
                                header-background-color="#fb8103"
                                hover-day-back-color="#fb8103"
                                chosen-day-back-color="#fb8103"
                                class="vs-inputx vs-input--input hasValue hasIcon"
                                style="border : 1px solid rgba(0, 0, 0, 0.2)"
                                v-model="addUser.birth_date"								
                            ></pdatepicker>
                            <i class="vs-icon notranslate icon-scale icon-inputx notranslate vs-input--icon feather icon-calendar null icon-no-border"></i>
                        </div>
                    </div>
                    <span class="text-danger text-sm"></span>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        name="city"
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-map-pin"
                        icon-no-border
                        label-placeholder="شهر"
                        v-model="addUser.city"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        name="state"
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-map-pin"
                        icon-no-border
                        label-placeholder="استان"
                        v-model="addUser.state"
                    />
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-2">
                    <div class="vs-component vs-con-input-label vs-input w-full vs-input-primary is-label-placeholder">
                        <v-select :options="options" v-model="addUser.gender" :clearable="false" />
                    </div>
                    <span class="text-danger text-sm"></span>
                </div>
                <!-- <div class="vx-col sm:w-1/3 w-full mb-2">
                    <vs-input
                        v-validate="'required'"
                        data-vv-validate-on="blur"
                        name="password"
                        class="w-full"
                        icon-pack="feather"
                        icon="icon-map-pin"
                        icon-no-border
                        label-placeholder="رمز عبور"
                        v-model="addUser.password"
                    />
                    <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                </div> -->
                
            </div>

            <vs-row class="mt-4" vs-w="12" vs-type="flex" vs-justify="center">
                <vs-col vs-type="flex" vs-align="center" class="sm:w-1/2 w-full">
                    <vs-checkbox v-model="sms" class="">ارسال پیامک</vs-checkbox>
                </vs-col>
                <vs-col class="sm:w-1/2 w-full">
                    <vs-button class="mr-3 float-right" @click="addUserInfo()" :disabled="!validateForm">ثبت</vs-button>
                </vs-col>
            </vs-row>
    
        </div>
    </vs-popup>
</template>

<script>
import vSelect from 'vue-select'

export default {
    name: 'AddUser',
    props: {
        popupAddUser: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        vSelect,
    },

    computed: {
        validateForm() {
            return this.addUser.name != '' && this.addUser.last_name != '' && this.addUser.phone_number != '';
        },
    },
    
    data() {
		return{
            showPopup: false,
            addUser: {
                name: '',
                last_name: '',
                phone_number: '',
                email: '',
                birth_date: '',
                city: '',
                state: '',
                gender: {
					label: 'آقا',
					value: 'male',
				},
            },
            sms: true,
            options: [
				{
					label: 'آقا',
					value: 'male',
				},
				{
					label: 'خانم',
					value: 'female',
				},
			]
		}
    },

    watch: { 
      	popupAddUser: function(newVal) {
            this.showPopup = newVal
        },

        showPopup: function(newVal) {
            this.$emit('updatePopupAddUser', newVal)
            this.addUser = {
                name: '',
                last_name: '',
                phone_number: '',
                email: '',
                birth_date: '',
                city: '',
                state: '',
                gender: {
					label: 'آقا',
					value: 'male',
				},
            }
        },
    },
    
    methods: {
        addUserInfo(){
            this.$vs.loading()
            this.$emit('updatePopupAddUser', false)
			let sms = ''
			if(this.sms == true){
				sms = 1
			}
			else{
				sms = 0
			}
			let user = {
				name : this.addUser.name,
				last_name : this.addUser.last_name,
				phone_number : this.addUser.phone_number,
				email : this.addUser.email,
				gender : this.addUser.gender.value,
				birth_date : this.addUser.birth_date,
				state : this.addUser.state,
				city : this.addUser.city,
				sms : sms,
			}
			this.addUser = {
                name: '',
                last_name: '',
                phone_number: '',
                email: '',
                birth_date: '',
                city: '',
                state: '',
                gender: {
					label: 'آقا',
					value: 'male',
                },
            }
            this.sms = true
			this.$store.dispatch('addUser', user)
			.then(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'کاربر با موفقیت افزوده شد.',
					iconPack: 'feather',
					icon: 'icon-check-square',
					color: 'success'
				})
			})
			.catch(() => {
				this.$vs.loading.close()
				this.$vs.notify({
					title: '',
					text: 'اطلاعات وارد شده صحیح نمی باشد.',
					iconPack: 'feather',
					icon: 'icon-alert-circle',
					color: 'warning'
				})
			})
		},
    }
}
</script>

<style>
.con-vs-popup .vs-popup {
    width: 80% !important;
}

.day-box:hover ,.month-box:hover ,.year-box:hover , .chosen-day, .chosen-month, .chosen-year{
    color: #fff!important;
}

.day-name:hover{
    color: #000!important;
}

.pdatepicker input{
	border: none!important;
	text-align: left!important;
	width: 100px!important;
}
</style>